export default "__VITE_ASSET__DCIprb61__"